import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { connect } from "react-redux"
import "react-drawer/lib/react-drawer.css"

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  openAnn
} from "../../store/actions"

const Header = props => {
  const { ann, onOpenAnn } = props
  const history = useHistory()
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [showFullscreenPrompt, setShowFullscreenPrompt] = useState(false)
  const [userDismissed, setUserDismissed] = useState(false)

  useEffect(() => {
    // Check if we should show fullscreen prompt on initial load
    const isFullscreen = document.fullscreenElement || 
                        document.mozFullScreenElement || 
                        document.webkitFullscreenElement

    if (!isFullscreen) {
      setShowFullscreenPrompt(true)
    }

    // Listen for fullscreen changes
    const handleFullscreenChange = () => {
      const isNowFullscreen = document.fullscreenElement || 
                              document.mozFullScreenElement || 
                              document.webkitFullscreenElement

      // If user exits fullscreen manually (not via our button), show prompt again
      if (!isNowFullscreen && !userDismissed) {
        // Small delay to ensure fullscreen state is updated
        setTimeout(() => {
          setShowFullscreenPrompt(true)
        }, 300)
      }
    }

    // Add listeners for all browser vendors
    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange)
    document.addEventListener('msfullscreenchange', handleFullscreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange)
      document.removeEventListener('msfullscreenchange', handleFullscreenChange)
    }
  }, [userDismissed])

  const handleEnterFullscreen = () => {
    setShowFullscreenPrompt(false)
    setUserDismissed(false) // Reset dismissed state when user chooses to enable
    toggleFullscreen()
  }

  const handleDismissPrompt = () => {
    setShowFullscreenPrompt(false)
    setUserDismissed(true) // User explicitly dismissed, don't show again this session
  }

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    }
  }

  function tToggle() {
    var body = document.body
    body.classList.toggle("vertical-collpsed")
    body.classList.toggle("sidebar-enable")
  }

  return (
    <React.Fragment>
      {/* Fullscreen Prompt Modal */}
      {showFullscreenPrompt && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #310147, #13011d, #240069)',
            padding: '30px 80px',
            borderRadius: '20px',
            maxWidth: '400px',
            textAlign: 'center',
            // boxShadow: '0 0 2px 4px #d0b24f55',
            border: "3px solid #fde490" ,
            borderBottom: "3px solid #966223",
            borderLeft: "3px solid #966223"
          }}>
            <i className="bx bx-fullscreen" style={{ fontSize: '48px', color: '#d0b24f', marginBottom: '15px' }}></i>
            {/* <h4 style={{ marginBottom: '15px', color: '#d0b24f' }}>Enable Fullscreen Mode?</h4> */}
            <h6 style={{ marginBottom: '25px', fontSize: "17px", color: '#ffffff' }}>
              Best viewed in full screen <h4 style={{ color: '#d0b24f' }}> Please Proceed</h4>
            </h6>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button 
                onClick={handleEnterFullscreen}
                className="btn applebtn"
              >
                <i className="bx bx-check me-1"></i>
                OK 
                {/* <i className="bx bx-fullscreen ms-1 me-1" />  */}
              </button>
              {/* <button 
                onClick={handleDismissPrompt}
                className="btn btn-secondary"
                style={{ minWidth: '120px' }}
              >
                Maybe Later
              </button> */}
            </div>
          </div>
        </div>
      )}

      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className='bx bx-menu' style={{ fontSize: '25px' }}></i>
            </button>
            <button
            style={{ display: "none" }}
              type="button"
              onClick={() => {
                history.push("/page/Lobby")
              }}
              className="btn btn-sm  font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-chevron-left" />
            </button>
          </div>
          <div className="d-flex">
          <div className="dropdown  d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={onOpenAnn}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="bx bx-bell bx-tada" />
              </button>
            </div>
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>
            
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  ann: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  openAnn: PropTypes.func,
}

const mapStatetoProps = (state,agenda) => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout
  const {ann}=agenda
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType,ann }
}

const mapDispatchToProps = dispatch => ({
  onOpenAnn: () => dispatch(openAnn()),
})

export default connect(mapStatetoProps,  mapDispatchToProps)(withTranslation()(Header))